import configApi from './config/config-api'
import creditApplicationApi from './creditApplication/creditApplication-api'

export default {
  config: configApi,
  creditApplication: creditApplicationApi,
}
